import moment from "moment";
import React, { useCallback, useState } from "react";

import WorklogMissingForm from "./WorklogMissingForm";
import FormDialog from "../Dialog/FormDialog";

function MissingItem({ worklog, daily_worklog_hours }) {
  const [dialog, setDialog] = useState(false);

  const handleClose = useCallback(() => {
    setDialog(false);
  }, []);

  const formatHours = (hours) => {
    const num = Number(hours);
    return Number.isInteger(num) ? num.toString() : num.toFixed(2);
  };

  const date = new Date(worklog.date);
  const dayName = date.toLocaleDateString("en-US", { weekday: "short" });

  return (
    <>
      <div className="d-flex justify-content-space-between ">
        <p className="date-hour">
          {` ${dayName} ${moment(worklog.date).format("MMM DD, YYYY")} (${formatHours(daily_worklog_hours - worklog?.total_hours_spent)} hrs)`}
        </p>
        <a className="cursor-pointer" onClick={() => setDialog(true)}>
          Didn't work
        </a>
      </div>
      {dialog && (
        <FormDialog
          open={dialog}
          title={"Worklog Missing"}
          handleClose={handleClose}
          fullWidth={true}>
          <WorklogMissingForm
            date={worklog.date}
            time={daily_worklog_hours - worklog?.total_hours_spent}
            handleClose={handleClose}
            dayName={dayName}
          />
        </FormDialog>
      )}
    </>
  );
}

export default React.memo(MissingItem);
